import { postData } from "../services/apiService";


export const subscribeUser = (data) => postData("/subscriber", data);
